import { apiBaseURL } from "../ProjectConstants";

const ok = (r) =>
  r?.success && r?.data?.statusCode && r?.success !== "Invalid Model";

// Build multipart/form-data for Work Center (PUT/POST)
const buildWorkCenterFormData = (row) => {
  const fd = new FormData();
  fd.append("Name", row.name ?? "");
  const typeText =
    row.type === 0
      ? "Research"
      : row.type === 1
        ? "Operation"
        : String(row.type ?? "");
  fd.append("Type", typeText);
  // one field per id: what the default MVC form binder expects for a List<int>
  (row.tasks ?? []).forEach((taskId) => fd.append("WorkTasks", taskId));
  if (row.numberOfFulltimes != null)
    fd.append("NumberOFFulltimes", String(row.numberOfFulltimes));
  if (row.numberOfStudents != null)
    fd.append("NumberOfStudents", String(row.numberOfStudents));
  const raw = row.__imageFile;
  const file = Array.isArray(raw) ? raw[0] : raw;
  if (file && file.name) fd.append("Image", file, file.name);
  return fd;
};

export async function putWorkCenter(fetch, row) {
  const fd = buildWorkCenterFormData(row);
  const response = await fetch.putFile(
    `${apiBaseURL}/api/WorkCenter?id=${encodeURIComponent(row.id)}`,
    fd,
  );
  return { response, isDataGood: ok(response) };
}

/** POST /api/WorkCenter */
export async function postWorkCenter(fetch, row) {
  const fd = buildWorkCenterFormData(row);
  const response = await fetch.postFile(`${apiBaseURL}/api/WorkCenter`, fd);
  return { response, isDataGood: ok(response) };
}
